import React from 'react';
import { SALUD_MENTAL_DATA } from '@/data/mock';
import { SolutionPageLayout } from '@/components/shared/SharedComponents';
import {
  BookOpen, Wind, PenLine, Smile, PhoneCall, Bot,
  AlertCircle, ClipboardCheck, BarChart3,
  Heart, Headphones, Stethoscope
} from 'lucide-react';

const featureIcons = { BookOpen, Wind, PenLine, Smile, PhoneCall, Bot, AlertCircle, ClipboardCheck, BarChart3 };
const audienceIcons = { Heart, Headphones, Stethoscope };

export default function SaludMentalPage() {
  return (
    <SolutionPageLayout
      heroData={SALUD_MENTAL_DATA.hero}
      features={SALUD_MENTAL_DATA.features}
      stats={SALUD_MENTAL_DATA.stats}
      audiences={SALUD_MENTAL_DATA.audiences}
      featureIcons={featureIcons}
      audienceIcons={audienceIcons}
    />
  );
}
